import PaymentByLinkContainer from './create/container';

const PaymentByLinkRoute = PaymentByLinkContainer;

export default PaymentByLinkRoute;
